import { createPortal } from 'react-dom';

let tooltipsRoot = document.getElementById('tooltips-root');

interface TooltipPortalProps {
  hasNestedMenu: boolean;
}

const TooltipPortal: React.FC<TooltipPortalProps> = ({
  children,
  hasNestedMenu,
}) => {
  if (!hasNestedMenu) {
    return <>{children}</>;
  }
  return createPortal(children, tooltipsRoot!);
};

export default TooltipPortal;
